<style>
  .invoice-preview {
    background: #fff;
    color: #000;
    max-width: 900px;
    margin: 0 auto;
    height: 100%;
    padding: 24px 36px 36px 36px;
    box-sizing: border-box;
    font-family: Arial, Helvetica, sans-serif;
    line-height: 1.25rem;
  }
  .inv-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 24px;
  }
  .inv-logo img { height: 60px; }
  .inv-title {
    margin-left: auto;
    text-align: right;
  }
  .inv-title .page { color: #666; }
  .inv-title h1 { margin: 4px 0 0 0; font-size: 28px; font-weight: 600; }
  .inv-close {
    flex: 0 0 48px;
    margin: -8px -8px 0 8px;
  }

  .inv-meta {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 24px;
    row-gap: 8px;
    margin-bottom: 24px;
  }
  .inv-box { font-size: 14px; }
  .inv-box h3 { margin: 0 0 6px 0; font-size: 14px; font-weight: 700; }
  .muted { color: #444; }

  .inv-cols {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 24px;
    margin-bottom: 12px;
  }
  .keyval { display: grid; grid-template-columns: auto 1fr; column-gap: 12px; row-gap: 4px; }
  .keyval div.key { color: #444; }

  .line { height: 1px; background: #cfcfcf; margin: 18px 0; }

  table.inv-table { width: 100%; border-collapse: collapse; margin-top: 8px; }
  table.inv-table thead th { text-align: left; border-bottom: 1px solid #cfcfcf; padding: 8px 4px; font-weight: 700; }
  table.inv-table tbody td { padding: 10px 4px; border-bottom: 1px solid #eee; vertical-align: top; font-size: 14px; }
  table.inv-table td.sum { text-align: right; white-space: nowrap; }

  .notes { color: #333; margin: 20px 0 24px 0; }
  .preserve { white-space: pre-line; font-size: 14px; }
  .times-block { margin-top: 14px; font-size: 14px; }

  .totals {
    margin-top: 8px;
    border-top: 1px solid #cfcfcf;
    border-bottom: 1px solid #cfcfcf; /* full-width line under totals */
    padding: 12px 0; /* top and bottom padding to separate lines */
    display: grid;
    grid-template-columns: repeat(5, 1fr) max-content; /* even spacing left of pay */
    gap: 12px;
    font-size: 14px;
  }
  .totals .pay { grid-column: 6; justify-self: end; text-align: right; }
  .totals div { padding-top: 0; }
  .totals .pay { text-align: right; font-weight: 700; font-size: 16px; }
  .bank-line { margin-top: 6px; color: #333; white-space: nowrap; }

  .footer {
    margin-top: 24px;
    color: #333;
  }
  .footer-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 12px; margin-top: 10px; }
  .right { text-align: right; }

  @media (max-width: 600px), (max-height: 500px) and (max-width: 960px) {
    .invoice-preview {
      width: 100%;
      max-width: none;
      padding: 16px;
      overflow-x: hidden;
      font-size: 13px;
      line-height: 1.4;
    }

    .inv-header {
      align-items: center;
      margin-bottom: 18px;
    }

    .inv-logo img {
      max-width: 140px;
      height: 40px;
      object-fit: contain;
    }

    .inv-title h1 {
      font-size: 20px;
    }

    .inv-close {
      margin-left: 4px;
    }

    .inv-meta,
    .inv-cols {
      grid-template-columns: 1fr;
      gap: 14px;
      margin-bottom: 18px;
    }

    .keyval {
      grid-template-columns: minmax(90px, auto) minmax(0, 1fr);
      column-gap: 10px;
    }

    table.inv-table {
      table-layout: fixed;
    }

    table.inv-table th:last-child,
    table.inv-table td.sum {
      width: 86px;
    }

    .preserve,
    .times-block,
    table.inv-table tbody td {
      overflow-wrap: anywhere;
      font-size: 13px;
    }

    .notes {
      margin: 16px 0;
    }

    .totals {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 12px 16px;
      font-size: 13px;
    }

    .totals .pay {
      grid-column: 1 / -1;
      justify-self: stretch;
      padding-top: 10px;
      border-top: 1px solid #eeeeee;
      text-align: right;
    }

    .bank-line {
      white-space: normal;
      overflow-wrap: anywhere;
    }

    .footer {
      margin-top: 18px;
    }

    .footer-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 16px;
    }

    .footer-grid > div {
      min-width: 0;
      overflow-wrap: anywhere;
    }
  }

  /* Prevent dialog container padding from squeezing content */
  :host { display: block; height: 100%; }
</style>

<div class="invoice-preview">
  <div class="inv-header">
    <div class="inv-logo">
      <img [src]="logo" alt="SAMpoolen" />
    </div>
    <div class="inv-title">      
      <h1>Förhandsgranskning</h1>
    </div>
    <button type="button" mat-icon-button mat-dialog-close class="inv-close" aria-label="Stäng förhandsgranskningen">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="inv-meta">
    <div class="inv-box"></div>

    <div class="inv-box">
      <div class="keyval" *ngIf="false">
        <div class="key">Fakturadatum</div>
        <div>{{today | swedishDate: 'yyyy-MM-dd'}}</div>
        <div class="key">Fakturanr</div>
        <div>{{data?.InvoiceNumber || '-'}}</div>
        <div class="key">OCR</div>
        <div>{{data?.Ocr || '-'}}</div>
      </div>
      <h3 class="muted">Kund</h3>
      <div>{{data?.Customer?.Name}}</div>
      <div *ngIf="data?.Customer?.Address">{{data.Customer.Address}}</div>
      <div *ngIf="data?.Customer?.Zip || data?.Customer?.City">{{data.Customer.Zip}} {{data.Customer.City}}</div>
      <div *ngIf="data?.Customer?.Country?.Name">{{data.Customer.Country.Name}}</div>
    </div>
  </div>

  <div class="inv-cols">
    <div class="inv-box">
      <div class="keyval">
        
        <div class="key">Er referens</div>
        <div>{{data?.Reference?.Name || '-'}}</div>
        <div class="key">Ert ordernr</div>
        <div>{{data?.ReferenceText || '-'}}</div>
      </div>
    </div>
    <div class="inv-box">
      <div class="keyval">
        <div class="key">Vår referens</div>
        <div>{{data?.UserSettings?.DisplayName}}</div>
        <div class="key">Betalningsvillkor</div>
        <div>{{data?.PaymentTerm || 30}} dagar</div>
        <div class="key">Förfallodatum</div>
        <div>{{ (getDueDate() || today) | swedishDate:'yyyy-MM-dd' }}</div>
      </div>
    </div>
  </div>

  <div class="line"></div>

  <table class="inv-table">
    <thead>
      <tr>
        <th>Benämning</th>
        <th class="right">Summa</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let g of data?.InvoiceGroups" [hidden]="isWorkedHoursGroup(g)">
        <td>
          <div class="preserve">{{g?.Description}}</div>
          <!-- SumTime: show first and last date + total time -->
          <div class="times-block" *ngIf="g?.InvoiceRows?.length && g?.TimeReportStatus && (g.TimeReportStatus.Name == 'SumTime' || g.TimeReportStatus.Id == 2)">
            {{g?.InvoiceRows[0]?.StartDate | swedishDate:'yyyy-MM-dd'}} -
            {{g?.InvoiceRows[g.InvoiceRows.length-1]?.StartDate | swedishDate:'yyyy-MM-dd'}} ({{getGroupTotalHours(g)}})
          </div>
          <!-- DetailedInfo or default: show each date with hours/minutes -->
          <div class="times-block" *ngIf="g?.InvoiceRows?.length && (!g?.TimeReportStatus || g.TimeReportStatus.Name == 'DetailedInfo' || g.TimeReportStatus.Id == 1)">
            <span *ngFor="let r of g.InvoiceRows; let i = index">
              {{r?.StartDate | swedishDate:'yyyy-MM-dd'}}<span *ngIf="r?.HoursWorked || r?.MinutesWorked"> ({{r?.HoursWorked || 0}} h<span *ngIf="r?.MinutesWorked && r.MinutesWorked > 0"> {{r.MinutesWorked}} min</span>)</span><span *ngIf="i < g.InvoiceRows.length-1">, </span>
            </span>
          </div>
          <!-- NoInfo (or other): do not show dates -->
        </td>
        <td class="sum">{{g?.Amount | number:'1.2-2'}} {{data?.Currency?.Name}}</td>
      </tr>
    
    
    <!-- Deductions (Utlägg) added to invoice -->
    <ng-container *ngFor="let g of data?.InvoiceGroups">
      <ng-container *ngIf="g?.Deductions?.length">
        <ng-container *ngFor="let d of g.Deductions">
          <tr *ngIf="d?.AddedToInvoice === true">
            <td>
              <div class="preserve">Utlägg<span *ngIf="d?.Description">: {{ d.Name }}</span></div>
            </td>
            <td class="sum">{{ (d?.AgreedInvoiceAmount ?? d?.Amount) | number:'1.2-2' }} {{data?.Currency?.Name}}</td>
          </tr>
        </ng-container>
      </ng-container>
    </ng-container>

    <!-- Allowances (Reseersättning/Traktamente) added to invoice -->
    <ng-container *ngFor="let g of data?.InvoiceGroups">
      <ng-container *ngIf="g?.Allowances?.length">
        <ng-container *ngFor="let a of g.Allowances">
          <tr *ngIf="a?.AddedToInvoice === true">
            <td>
              <div class="preserve">{{ a?.AllowanceType?.Name || 'Reseersättning/Traktamente' }}<span *ngIf="a?.Description">: {{ a.Description }}</span></div>
            </td>
            <td class="sum">{{ getAllowanceBilledAmount(a) | number:'1.2-2' }} {{data?.Currency?.Name}}</td>
          </tr>
        </ng-container>
      </ng-container>
    </ng-container>

    <!-- Top-level deductions if not grouped -->
    <ng-container *ngIf="!hasGroupedDeductions() && data?.Deductions?.length">
      <ng-container *ngFor="let d of data.Deductions">
        <tr *ngIf="d?.AddedToInvoice === true">
          <td>
            <div class="preserve">Utlägg<span *ngIf="d?.Description">: {{ d.Name }}</span></div>
          </td>
          <td class="sum">{{ (d?.AgreedInvoiceAmount ?? d?.Amount) | number:'1.2-2' }} {{data?.Currency?.Name}}</td>
        </tr>
      </ng-container>
    </ng-container>

    <!-- Top-level allowances if not grouped -->
    <ng-container *ngIf="!hasGroupedAllowances() && data?.Allowances?.length">
      <ng-container *ngFor="let a of data.Allowances">
        <tr *ngIf="a?.AddedToInvoice === true">
          <td>
            <div class="preserve">{{ a?.AllowanceType?.Name || 'Reseersättning/Traktamente' }}<span *ngIf="a?.Description">: {{ a.Description }}</span></div>
          </td>
          <td class="sum">{{ getAllowanceBilledAmount(a) | number:'1.2-2' }} {{data?.Currency?.Name}}</td>
        </tr>
      </ng-container>
    </ng-container>

    </tbody>

  </table>  <div class="vat-lines" *ngIf="getVatBreakdown().length" style="margin-top:8px;color:#333;">
  </div>

  <div class="notes">
    <div>SAMpoolen är Sveriges billigaste egenanställningstjänst.</div>
    <div>Med vår låga avgift får våra medlemmar högre lön än via andra egenanställningsbolag.</div>
    <div>Betalning via PayPal: ekonomi&#64;samgruppen.se</div>
    <div>SAMpoolen ingår i SAMgruppen AB.</div>
  </div>

  <div class="totals">
    <div *ngIf="getInvoiceFeeDisplay() > 0">
      <div class="muted">Fakt. avgift</div>
      <div>{{ getInvoiceFeeDisplay() | number:'1.2-2' }}</div>
    </div>
    <div>
      <div class="muted">Exkl. moms</div>
      <div>{{ getSubtotalExclVat() | number:'1.2-2' }}</div>
    </div>
    <div>
      <div class="muted">Moms</div>
      <div>{{ getVatTotal() | number:'1.2-2' }}</div>
    </div>
    <div *ngIf="getRoundingAdjustment() !== 0">
      <div class="muted">Öresavr</div>
      <div>{{ getRoundingAdjustment() | number:'1.2-2' }}</div>
    </div>
    <div>
      <div class="muted">Totalt</div>
      <div>{{ getTotalInclVat() | number:'1.2-2' }}</div>
    </div>
    <div class="pay">
      <div class="muted">ATT BETALA</div>
      <div>{{ (data?.Currency?.Name || 'SEK') }} {{ getRoundedPayTotal() | number:'1.2-2' }}</div>
    </div>
  </div>

  <div class="bank-line">IBAN SE37 5000 0000 0521 5106 6312 BIC ESSESESSXXX</div>

  <div class="footer">
    <div class="footer-grid">
      <div>
        <div class="muted">Adress</div>
        <div>SAMgruppen AB</div>
        <div>Kivra: 559012-7253</div>
        <div>10631 Stockholm</div>
      </div>
      <div>
        <div class="muted">Telefon</div>
        <div>08-51 81 64 40</div>
        <div class="muted">E-post</div>
        <div>info&#64;samgruppen.se</div>
      </div>
      <div>
        <div class="muted">Bankgiro</div>
        <div>469-5250</div>
        <div class="muted">Säte</div>
        <div>Stockholm</div>
      </div>
      <div>
        <div class="muted">Organisationsnr</div>
        <div>559012-7253</div>
        <div class="muted">Momsreg. nr</div>
        <div>SE559012725301</div>
      </div>
    </div>
  </div>
</div>

